import { number, string, shape } from 'prop-types';
import classnames from 'classnames';
import Head from 'next/head';
import React, { Fragment } from 'react';
import AmpImg from 'components/AmpImg';
import styles from './styles';

// This is a VERY basic teaser implementation! If we want to use it beyond the
// below post recirc it will likely require additional work.

function AmpTeaser({
  headline,
  promotedAt,
  imageUrl,
  dek,
  cta,
  variant,
  imgProps,
  originalHeight,
  originalWidth
}) {
  const date = new Date(promotedAt * 1000);

  return (
    <Fragment>
      <Head>
        <script
          key="amp-timeago"
          async
          custom-element="amp-timeago"
          src="https://cdn.ampproject.org/v0/amp-timeago-0.1.js"
        />
      </Head>
      <div
        className={classnames('AmpTeaser', {
          [`AmpTeaser--${variant}`]: variant
        })}
      >
        <div className="AmpTeaser__picture">
          {imageUrl && (
            <AmpImg
              url={imageUrl}
              alt={headline}
              maxSize={imgProps}
              originalHeight={originalHeight}
              originalWidth={originalWidth}
              isFixedSize={variant === 'recipeRoundup'}
            />
          )}
        </div>
        <div className="AmpTeaser__body">
          <h2
            className="AmpTeaser__headline"
            dangerouslySetInnerHTML={{ __html: headline }}
          />
          {date && variant === 'default' && (
            <amp-timeago datetime={date.toISOString()} width={160} height={20}>
              {date.toString()}
            </amp-timeago>
          )}
          {variant === 'recipeRoundup' && dek && (
            <div className="AmpTeaser__dek">{dek}</div>
          )}
          {variant === 'recipeRoundup' && cta && (
            <div className="AmpTeaser__cta">
              <span>{cta}</span>
            </div>
          )}
        </div>
      </div>
      <style jsx>{styles}</style>
    </Fragment>
  );
}

AmpTeaser.defaultProps = {
  headline: '',
  imageUrl: undefined,
  promotedAt: 0,
  variant: 'default',
  cta: undefined,
  dek: undefined,
  imgProps: {
    maxSize: {
      width: 200
    }
  },
  originalHeight: undefined,
  originalWidth: undefined
};

AmpTeaser.propTypes = {
  headline: string,
  imageUrl: string,
  promotedAt: number,
  dek: string,
  cta: string,
  variant: string,
  imgProps: shape({
    maxSize: shape({
      width: number,
      aspectRatio: number
    })
  }),
  originalHeight: number,
  originalWidth: number
};

export default AmpTeaser;
